<template>
  <div
    class="u-flex u-flex-spaceBetween"
    style="margin-bottom: 55px;"
  >
    <div>
      <h2 class="PageHeader">
        {{ event.name }}
      </h2>
      <p>
        {{ event.last_update_at }}
      </p>
    </div>

    <preview-form-button />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PreviewFormButton from './preview-form-button';

export default {
  components: {
    PreviewFormButton,
  },
  computed: {
    ...mapState('events', {
      event: (state) => state.event,
    }),
  },
};
</script>
<style scoped lang="less">
.CreationSteps {
  position: absolute;
  top: -40px;
  left: 0;

  @media only screen and (max-width: 1490px) {
    width: 100%;
  }

  a {
    color: grey;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 8px 10px;
    background: rgba(255, 255, 255, 0.54);
    border: 1px solid #eaeaea;

    &.disabled {
      opacity: 0.3;
      pointer-events: none;
    }
    &.current-view {
      color: black;
      background: white;
      border-bottom: none;
      flex-shrink: 0;
    }

    .Icon-check-circle {
      color: #046ff0;
    }

  }
}
</style>
